module.exports = __webpack_public_path__ + "static/media/genista-logo.869d4db8.svg";